import { NgbDateISOParserFormatter } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-parser-formatter';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import { InstituicaoModel } from '../../instituicao/shared/index';
import { SituacaoCadastroConsumidorModel } from './situacao-cadastro-consumidor.model';
import { RepresentanteLegalModel } from '../../representanteLegal/shared/representante-legal.model';

export class ConsumidorModel {

    public consumidorId: number;
    public cpf: string;
    public cpfBase: number;
    public cpfDigito: number;
    public nome: string;
    public senha: string;
    public token: string;
    public fraseSeguranca: string;
    public codigoMunicipioIBGE: number;
    public bairro: string;
    public logradouro: string;
    public numeroEndereco: string;
    public complementoEndereco: string;
    public cep: string;
    public emailPrincipal: string;
    public emailOpcional: string;
    public dddTelefone: number;
    public telefone: number;
    public dddCelular: number;
    public celular: number;
    public nomeMae: string;
    public dataNascimento;
    public statusParticipanteSorteio: number;
    public situacaoCadastroConsumidorId: number;
    public dataExclusao: string;
    public dataAtualizacao: string;
    public situacaoCadastroConsumidor: SituacaoCadastroConsumidorModel;
    public instituicoes: InstituicaoModel[];
    public notasParticipantes;
    public stsAutorizaNotificacao = 0;
    public stsParticipaSorteio = 1;
    public situacaoAutorizaNotificacao = 0;
    public dataCadastro: string;
    public mensagemRetorno: string;
    public ConcordaComRegulamento: number;
    public aceitaTermosLGPD: number;
    public codOrigemCadastro: number

    public representanteLegal: RepresentanteLegalModel;
}

export class ConsumidorFormatter {

    public static pad(num: number, size: number): string {
        let s = num + '';
        while (s.length < size) {
            s = '0' + s;
        }
        return s;
    }

    public static formataNumero(strValor): number {
        const regEx = /\^|~|\?|,|\*|\.|\-/g;
        let formatValor: string;
        if (strValor) {
            formatValor = strValor.toString().replace(regEx, '');
            return parseInt(formatValor);
        }
        return null;
    }

    public static formataString(strValor): string {
        const regEx = /\^|~|\?|,|\*|\.|\-/g;
        let formatValor: string;
        if (strValor) {
            formatValor = strValor.replace(regEx, '');
            return formatValor;
        }
        return null;
    }

    public static getTelefoneFormat(dddTelefone, telefone): string {
        let telefoneFormat = '';

        if (dddTelefone === null || dddTelefone === 0) {
            telefoneFormat = '(' + dddTelefone + ') ' + telefone;
        }

        return telefoneFormat;
    }

    public static formatStsCheckValue(valueCheck): number {
        return (valueCheck) ? 1 : 0;
    }

    public static setDateFromNgbDateStruct(ngbDate: NgbDateStruct) {
        return ConsumidorFormatter.pad(ngbDate.year, 2) + '-' +
               ConsumidorFormatter.pad(ngbDate.month, 2) + '-' +
               ConsumidorFormatter.pad(ngbDate.day, 2);
    }

    public static getDateNgbDateStruct(date: string) {

        const dateParser: NgbDateISOParserFormatter = new NgbDateISOParserFormatter();
        const dateNgb: NgbDateStruct = dateParser.parse(date);

        return dateNgb;
    }

    public static strDate2Date(dateString) {
        const dateParts = dateString.split('/');
        const dateObject = dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0] + 'T00:00:00';
        return dateObject;
    }

    public static date2StrDate(dateString) {
        const dateParts = new Date(dateString);
        const dateObject = ConsumidorFormatter.pad(dateParts.getDate(), 2) + '/' +
                           ConsumidorFormatter.pad(dateParts.getMonth() + 1, 2) + '/' +
                           ConsumidorFormatter.pad(dateParts.getFullYear(), 4);
        return dateObject;
    }

    public static strDateWithoutHourAndSlash(dateString) {
        const dateParts = dateString.split('/');
        const dateObject = dateParts[2] + dateParts[1] + dateParts[0];
        return dateObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/consumidor.model.ts